import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "carousel-indicators --carousel-bottom-indicators mb-0"
}
const _hoisted_3 = ["data-bs-target", "data-bs-slide-to", "aria-label"]
const _hoisted_4 = { class: "carousel-inner" }
const _hoisted_5 = ["data-bs-interval"]
const _hoisted_6 = { class: "" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["data-bs-target"]
const _hoisted_9 = ["data-bs-target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: 'imageCarousel-' + _ctx.id,
    class: "carousel carousel-fade slide loading-background w-100",
    "data-bs-ride": "carousel"
  }, [
    (_ctx.imagesList.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagesList, (img, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: index,
              type: "button",
              "data-bs-target": '#imageCarousel-' + _ctx.id,
              class: _normalizeClass({ active: index === _ctx.activeSlide }),
              "data-bs-slide-to": index,
              "aria-label": 'Slide ' + index
            }, null, 10, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagesList, (img, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass('carousel-item' + (index === 0 ? ' active' : '')),
          "data-bs-interval": img.interval ?? 8000
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: img.src,
              class: _normalizeClass('img-fluid ' + _ctx.imgClass),
              alt: img.alt
            }, null, 10, _hoisted_7)
          ])
        ], 10, _hoisted_5))
      }), 128))
    ]),
    (_ctx.imagesList.length > 1)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "carousel-control-prev w-auto",
          type: "button",
          "data-bs-target": '#imageCarousel-' + _ctx.id,
          "data-bs-slide": "prev"
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", {
            class: "carousel-control-prev-icon",
            "aria-hidden": "true"
          }, null, -1),
          _createElementVNode("span", { class: "visually-hidden" }, "Previa", -1)
        ]))], 8, _hoisted_8))
      : _createCommentVNode("", true),
    (_ctx.imagesList.length > 1)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "carousel-control-next w-auto",
          type: "button",
          "data-bs-target": '#imageCarousel-' + _ctx.id,
          "data-bs-slide": "next"
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", {
            class: "carousel-control-next-icon",
            "aria-hidden": "true"
          }, null, -1),
          _createElementVNode("span", { class: "visually-hidden" }, "Siguiente", -1)
        ]))], 8, _hoisted_9))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}